<div class="list-item">
  <app-photo
    size="m"
    [rounded]="true"
    [type]="'photo'"
    [id]="data?.photoId"
    [text]="data?.name"
    [showPreview]="false"
  ></app-photo>

  <div class="list-item__info">
    <div class="list-item__title">
      <span class="list-item__text text_size-m text_color-01 text_line-2">
        {{ data?.name }}
      </span>
    </div>

    <div *ngIf="data?.description" class="list-item__text text_size-xs text_color-03 text_truncate">
      {{ data?.description }}
    </div>

    <div *ngIf="data?.parentCommittees" class="list-item__text text_size-xs text_color-03 text_truncate">
      {{ data?.parentCommittees | getCommitteePath }}
    </div>
  </div>
</div>
